// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_c6-0";